export function placementName(id, entities) {
    const entity = entities.find((item) => item.id === id);
    if (!entity) return 'Placement unavailable';
    const parent = entities.find((item) => item.id === entity.parent_entity_id);
    return entity.level_type === 'market' && parent ? `${parent.name} / ${entity.name}` : entity.name;
}

export function staffAccessLabel(member, entities) {
    const enabled = member.command_center_enabled ?? Boolean(member.command_center_role);
    if (!enabled) return 'Access: No Central Command access';
    const scopes = member.command_center_entity_ids || [];
    if (!scopes.length && ['owner', 'admin'].includes(member.command_center_role)) {
        const organization = entities.find((item) => item.level_type === 'organization');
        return `Access: Entire organization (${organization?.name || 'Organization'})`;
    }
    return `Access: ${scopes.length ? scopes.map((id) => entities.find((item) => item.id === id)?.name || 'Scope unavailable').join(', ') : 'No Companies/Markets selected'}`;
}

export function SecondaryPlacementEditor({ entities, homeId, value = [], onChange, canEditTarget }) {
    return <fieldset className="space-y-2">
        <legend className="text-sm font-medium">Also works in</legend>
        <p className="text-xs text-[var(--ink-muted)]">Additional placements do not grant app access or create another employee ID.</p>
        {entities.filter((item) => ['company', 'market'].includes(item.level_type) && item.id !== homeId
            && (value.includes(item.id) || canEditTarget(item.id, null))).map((item) =>
            <label key={item.id} className="flex items-center gap-2 text-sm">
                <input type="checkbox" checked={value.includes(item.id)} onChange={(event) =>
                    onChange(event.target.checked ? [...value, item.id] : value.filter((id) => id !== item.id))} />
                {placementName(item.id, entities)}
            </label>)}
    </fieldset>;
}

export function StaffPlacementSummary({ member, entities = [] }) {
    return <div className="space-y-2 text-xs text-[var(--ink-muted)]">
        <div>Home placement: {placementName(member.entity_id, entities)}</div>
        {!!member.secondary_entity_ids?.length && <div className="flex flex-wrap gap-1">
            <span>Also works in:</span>{member.secondary_entity_ids.map((id) =>
                <span key={id} className="rounded-full border border-[var(--surface-border)] px-2">{placementName(id, entities)}</span>)}
        </div>}
        <div>{staffAccessLabel(member, entities)}</div>
    </div>;
}

export function StaffPlacementChart({ staff, entities }) {
    return <div aria-label="Staff placement org chart" className="space-y-3">
        <p className="text-sm">Solid line: home (HR/payroll). Dotted line: also works in. Placement never grants access.</p>
        {entities.map((entity) => {
            const placements = staff.flatMap((member) => [
                ...(member.entity_id === entity.id ? [{ member, home: true }] : []),
                ...(member.secondary_entity_ids?.includes(entity.id) ? [{ member, home: false }] : []),
            ]);
            if (!placements.length) return null;
            return <section key={entity.id} className="rounded-lg border border-[var(--surface-border)] p-3">
                <h3 className="font-semibold">{placementName(entity.id, entities)}</h3>
                {placements.map(({ member, home }) => <div key={member.id} data-placement={home ? 'home' : 'secondary'}
                    style={{ borderLeftStyle: home ? 'solid' : 'dotted' }}
                    className="ml-4 mt-2 border-l-2 border-[var(--ink-muted)] pl-4 text-sm">
                    {member.full_name} · {member.title} · {home ? 'Home' : 'Also works in'}
                </div>)}
            </section>;
        })}
    </div>;
}
